<template>
  <div class="head-wrapper">
    <div class="head-top-wrapper">
      <header class="head-top">
        <section class="head-left">
          <a class="left-link ask" href="http://wenda.9man.com/wenda" target="_blank">全优问答</a>
          <a class="left-link" target="_blank" href="/study/download">APP下载</a>
          <a href="javascript:void(0)" class="left-link follow">关注公众号</a>
          <div class="code">
            <div class="img-wrapper">
              <img src="./qr-code.jpg" alt="qr-code" width="100%" height="100%">
            </div>
            <p class="img-title">打开微信扫一扫并关注</p>
            <p class="code-text">关注公众号接收上课和报名最新消息</p>
          </div>
        </section>
        <section class="head-right">
          <router-link to="/console" class="hr-link teacherShow" v-if="consoleShow">老师管理后台</router-link>
          <section class="unlogin" v-if="id==false">
            <router-link to="/log" class="hr-link">登录</router-link>
            <router-link to="/register" class="hr-link no-margin">注册</router-link>
          </section>
          <section class="logged">
            <span class="text">{{decodeURIComponent(userinfo.uname)}}</span>
            <ul class="second-ul">
              <li class="second-li" @click="clearOut">退出当前账号</li>
            </ul>
          </section>
        </section>
      </header>
    </div>

    <div class="head-mid">
      <div class="logo-wrapper">
        <a href="/">
          <img src="./logo.jpg" alt="logan" width="192" height="43">
        </a>
      </div>
      <ul class="link-wrapper" v-show="linkShow">
        <li class="link"><a href="/">首页精选</a></li>
        <li class="link">
          <router-link to="/account/personal/schedule" :class="{active:nowChose=='mystudy'}">我的学习</router-link>
        </li>
        <li class="link">
          <a href="/study/joinin">老师入驻</a>
        </li>
        <li class="link">
          <a href="/study/about">关于我们</a>
        </li>
      </ul>
      <div class="search">
        <input id='input-text'
               type="text"
               v-model="searchText"
               placeholder="搜索你想学的课程或内容"
               class="search-input"
               @keydown="searchKeyWord($event)">
        <span class="search-btn search-btn-hooker" @click="searchToo"></span>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  export default{
    props: {
      nowChose: {
        type: String,
      },
      linkShow:{
        type:Boolean,
        default:true,
      }
    },
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        userinfo: (() => loadLocal('userinfo', false))(),
        searchText: '',
        myurl: '',
        consoleShow: false,
      }
    },
    methods: {
      searchKeyWord(event){
        if (event.keyCode == "13") {
          let inputValue = this.searchText;
          inputValue = inputValue.trim();
          if (inputValue !== '') {
            window.location.href = '/study/search?keyword=' + inputValue + '&pageno=1';
          }
        }
      },
      searchToo(){
        let inputValue = this.searchText;
        inputValue = inputValue.trim();
        if (inputValue !== '') {
          window.location.href = '/study/search?keyword=' + inputValue + '&pageno=1';
        }
      },
      clearOut(){
        this.id = false;
        window.localStorage.clear();
        window.sessionStorage.clear();
        window.location.href = '/';
        this.$forceUpdate();
      },
      //用户点击更改用户信息
      showChangeUserinfo(){
        this.uname = decodeURIComponent(this.userinfo.uname);
        this.sex = decodeURIComponent(this.userinfo.sex);
        if (this.userinfo.headimg !== '') {
          this.imgurl = this.userinfo.headimgpath + decodeURIComponent(this.userinfo.headimg);
          this.upurl = decodeURIComponent(this.userinfo.headimg);
        }
        this.userinfoShow = true;
      },
      queryUserInfo(){
        //接口：查询班级课程目录列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'user',
            a: 'userinfo',
            id: this.id,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 200) {
            saveLocal('userinfo', response);
            this.userinfo = response;
          }
        }).catch((err) => {
          this.queryUserInfo();
        })
      }
    },
    created(){
      //获取当前的网页前缀
      //window.location是object对象格式
      let start = String(window.location).indexOf('#') + 1;
      this.myurl = String(window.location).substring(start);

      //根据userinfo获取用户是否为老师
      if (this.userinfo.identity === 1) {
        this.consoleShow = true;
      }
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  //头部链接的颜色
  $linkColor = #ccc;
  $linkHoverColor = #fff;
  //标题大小和颜色
  $titleFontSize = 24px;
  $titleColor = #333;
  $themeColor = #ff6700;
  //小字的颜色
  $textColor = #888;

  .head-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 100;
    .head-top-wrapper {
      height: 44px;
      background: #2d2d2d;
      .head-top {
        margin: 0 auto;
        width: 1226px;
        position: relative;
        .head-left {
          float: left;
          height: 44px;
          .left-link {
            float: left;
            margin-right: 20px;
            height: 44px;
            line-height: 44px;
            font-size: 14px;
            color: $linkColor;
            cursor: pointer;
            &:hover {
              color: $linkHoverColor
            }
            &.ask {
              padding-left: 30px;
              background: url('./ask1.png') no-repeat left center / 20px 20px;
              &:hover {
                background: url('./ask2.png') no-repeat left center / 20px 20px;
              }
            }
            &.follow:hover + .code {
              display: block;
            }
          }
          .code {
            display: none;
            position: absolute;
            top: 44px;
            left: 90px;
            width: 240px;
            background: #fff;
            padding: 30px 0 22px;
            box-sizing: border-box;
            box-shadow: 0 2px 4px #efefef;
            z-index: 6000;
            text-align: center;
            .img-wrapper {
              margin: 0 auto 14px;
              width: 174px;
              height: 174px;
            }
            .img-title {
              font-size: 14px;
              color: #666666;
              line-height: 19px;
              margin-bottom: 34px;
            }
            .code-text {
              margin: 0 30px;
              font-size: 13px;
              color: #999999;
              line-height: 18px;
            }
            &:hover {
              display: block;
            }
          }
        }
        .head-right {
          float: right;
          height: 44px;
          .hr-link {
            float: left;
            margin-right: 20px;
            height: 44px;
            line-height: 44px;
            font-size: 14px;
            color: $linkColor;
            cursor: pointer;
            &.no-margin {
              margin: 0;
            }
            &:hover {
              color: $linkHoverColor;
            }
          }
          .unlogin {
            float: left;
          }
          .logged {
            float: right;
            position: relative;
            .text {
              height: 44px;
              line-height: 44px;
              font-size: 14px;
              color: $linkColor;
              cursor: pointer;
            }
            &:hover .second-ul {
              display: block;
            }
            .second-ul {
              display: none;
              position: absolute;
              top: 100%;
              right: 0;
              z-index: 100;
              background: #2d2d2d;
              .second-li {
                width: 86px;
                height: 37px;
                line-height: 37px;
                text-align: center;
                font-size: 12px;
                color: $linkColor;
                cursor: pointer;
                &:hover {
                  color: #fff;
                }
              }
            }
          }
        }
      }
    }
    .head-mid {
      clear: both;
      width: 1226px;
      height: 80px;
      margin: 0 auto;
      position: relative;
      .logo-wrapper {
        float: left;
        height: 43px;
        width: 192px;
        padding-top: 18px;
      }
      .link-wrapper {
        float: left;
        margin-left: 176px;
        height: 80px;
        .link {
          float: left;
          margin-right: 40px;
          a {
            float: left;
            height: 80px;
            line-height: 80px;
            width: 64px;
            font-size: 16px;
            color: $titleColor;
            &.active {
              color: $themeColor;
              border-bottom: 3px solid $themeColor;
            }
          }
        }
      }
      .search {
        float: right;
        height: 50px;
        width: 274px;
        border: 1px solid #ccc;
        margin-top: 15px;
        border-radius: 4px;
        box-sizing: border-box;
        padding-left: 18px;
        .search-input {
          float: left;
          width: 200px;
          height: 48px;
          line-height: 48px;
          box-sizing: border-box;
          font-size: 14px;
          color: #000;
          background: #fff;
          border: none;
          &:-moz-placeholder {
            color: #ccc;
          }
          &::-moz-placeholder {
            color: #ccc;
          }
          &:-ms-input-placeholder {
            color: #ccc;
          }
          &::-webkit-input-placeholder {
            color: #ccc;
          }
        }
        .search-btn {
          float: right;
          display: inline-block;
          height: 48px;
          width: 54px;
          background: url('./search.png') no-repeat left 10px center / 24px 24px;
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/globalheader/GlobalHeader.vue